/**
 * Dashboard-only hooks. The Opengater user total comes from the Users service
 * (8004), matching the source used by the support users screen. The banned
 * count remains a GlobalAuth metric because the Users service list does not
 * expose that filter.
 */
import { useQuery } from '@tanstack/react-query';
import { apiOg } from './client';
function useUsersCount() {
    return useQuery({
        queryKey: ['og', 'dash', 'users', 'total'],
        queryFn: () => apiOg('users', '/api/v1/admin/users?limit=1&offset=0'),
        select: (d) => d.total,
        refetchInterval: 60_000,
        refetchIntervalInBackground: false,
    });
}
function useAuthCount(key, query) {
    return useQuery({
        queryKey: ['og', 'dash', 'auth-users', key],
        queryFn: () => apiOg('auth', `/admin/users?${query}`),
        select: (d) => d.total,
        refetchInterval: 60_000,
        refetchIntervalInBackground: false,
    });
}
export function useOgUserTotal() {
    return useUsersCount();
}
export function useOgUserBanned() {
    return useAuthCount('banned', 'page=1&per_page=1&is_banned=true');
}
